import BaseModalApp from "../../../components/modals/app-modals/BaseModalApp";
import {
  ApplicationButton,
  ApplicationStateRegion,
} from "../../../components/application";
import ActivitySemanticSetup from "../../activity-authoring/components/ActivitySemanticSetup";

export default function AssignmentActivityInspectionModal({
  isOpen,
  inspection,
  loading,
  error,
  assignmentId,
  onClose,
}) {
  return <BaseModalApp
    isOpen={isOpen}
    onRequestClose={onClose}
    contentLabel="Assignment activity inspection"
    size="1000px"
    className="ReactModal__Content modal--app av-assignment-activity-modal"
  >
    <div className="av-assignment-activity-inspection__header">
      <div>
        <h2>{inspection?.name || "Activity details"}</h2>
        {inspection ? <p>{inspection.visibility === "only_you" ? "My activity" : "Provided by All-Voiced"}{inspection.lineage?.version ? ` · Version ${inspection.lineage.version}` : ""}</p> : null}
      </div>
      <ApplicationButton variant="quiet" onClick={onClose}>Close</ApplicationButton>
    </div>
    {loading ? <ApplicationStateRegion status="loading" message="Loading activity…" /> : null}
    {error ? <ApplicationStateRegion status="error" message={error} /> : null}
    {inspection ? <ActivitySemanticSetup activity={inspection} protectedMediaContext={assignmentId ? {
      consumerContext: "ASSIGNMENT_ACTIVITY_INSPECTION",
      assignmentId,
    } : null} /> : null}
  </BaseModalApp>;
}
